import type { Editor } from '@tiptap/core';

export const clearFormats = (editor: Editor | undefined) => {
  if (!editor) {
    return;
  }

  editor
    .chain()
    .focus()
    .unsetMark('bold')
    .unsetMark('underline')
    .unsetMark('italic')
    .unsetMark('strike')
    .unsetMark('subscript')
    .unsetMark('superscript')
    .setMark('textStyle', { color: null })
    .removeEmptyTextStyle()
    .run();
};
